import { create } from 'zustand';

/**
 * 全局状态管理
 * 
 * 步骤流程:
 * 1. idle - 初始状态，显示用户选择页面
 * 2. processing_recommendation - 正在调用推荐 API
 * 3. showing_result - 展示推荐结果
 * 4. processing_update - 正在调用更新 API
 * 5. showing_diff - 展示记忆更新对比
 */

const useAppStore = create((set) => ({
  // 当前步骤
  currentStep: 'idle',
  
  // 选中的用户 ID
  selectedUserId: null,
  
  // 选中的用户完整信息
  selectedUser: null,
  
  // 推荐结果数据
  recommendationResult: null,
  
  // 记忆更新对比数据
  memoryDiff: null,
  
  // 错误信息
  error: null,
  
  // Actions
  
  /**
   * 选择用户并开始推荐流程
   */
  selectUser: (userId, userInfo) => set({
    selectedUserId: userId,
    selectedUser: userInfo,
    currentStep: 'processing_recommendation',
    error: null
  }),
  
  /**
   * 设置推荐结果
   */
  setRecommendationResult: (result) => set({
    recommendationResult: result,
    currentStep: 'showing_result'
  }),
  
  /**
   * 开始记忆更新流程
   */
  startMemoryUpdate: () => set({
    currentStep: 'processing_update'
  }),
  
  /**
   * 设置记忆更新对比
   */
  setMemoryDiff: (diff) => set({
    memoryDiff: diff,
    currentStep: 'showing_diff'
  }),
  
  /**
   * 重置到初始状态
   */
  reset: () => set({
    currentStep: 'idle',
    selectedUserId: null,
    selectedUser: null,
    recommendationResult: null,
    memoryDiff: null,
    error: null
  }),
  
  /**
   * 设置错误信息
   */
  setError: (error) => set({
    error,
    currentStep: 'idle'
  }),
  
  /**
   * 设置当前步骤
   */
  setCurrentStep: (step) => set({
    currentStep: step
  })
}));

export default useAppStore;

